const labels = {
  FaqCategories: {
    'Ref: Page title': 'Câu hỏi thường gặp',
    'Ref: Missing Faq': 'Câu hỏi thường gặp trống',
    'Ref: Go to home page': 'Điều hướng đến trang chủ',
  },
  FaqCategoryDetails: { 'Ref: Page title': 'Câu hỏi' },
};
export default labels;
